import React from "react";
import BannerHero from "@/components/bannerHero";
import AboutLayout from "@/components/layout/AboutLayout";
import Image from "next/image";


const CaymanIslandsConference = () => {
    return (
        <>
            <BannerHero
                title="Cayman Islands Conference "
                bgImage="/images/about_cayman.webp"
                className="about-cayman"
            />
            <AboutLayout>
                <div className="text-center">
                    <h2 className="text-uppercase mb-4">Cayman Islands Conference</h2>
                    <div className="d-flex justify-content-center">
                        <Image
                            src="/images/under_progress.png"
                            alt="Under Construction"
                            width={500}
                            height={500}
                            className="img-fluid"
                        />
                    </div>
                    <p className="mt-4 text-muted">This page is currently under construction. Please check back soon!</p>
                </div>
            </AboutLayout>
        </>
    );
};

export default CaymanIslandsConference;
